import { Container, Title } from '@mantine/core';
import SellerStats from '../../components/seller/SellerStats';

const SellerAnalyticsPage = () => (
  <Container size="lg" py="xl">
    <Title order={1} mb="lg">Analytics</Title>
    <SellerStats />
  </Container>
);

export default SellerAnalyticsPage;
